import { useState } from "react"
import Button from "../../../components/button"
import CardContainer from "../../../components/card_container"
import Input from "../../../components/input"
import InputImage from "../../../components/input_image"
import InputSwitch from "../../../components/input_switch"
import "./productCategory.scss"
import UseFormProductCategory from "./hookForm"
import LoadingModal from "../../../components/loading_modal"

const EditProductCategoryPage = () => {
    const {
        isLoading,
        form,
        formData,
        isOn,
        handleSwitch,
        handleChange,
        handleImageChange,
        handleSubmit,
    } = UseFormProductCategory({
        type: "put"
    })

    return (
        <>
            <CardContainer
                title={"Edit Data"}
                isBack={true}
                children={(
                    <form className="" onSubmit={handleSubmit}>
                        <div className="form-product-category">
                            <div className="expanded-y">
                                <Input style={{ width: "100%", marginBottom: "20px" }} id="code" onChange={handleChange} value={form.code} label="Code" placeholder="Input code" required={true} />
                                <Input style={{ width: "100%", marginBottom: "20px" }} id="name" onChange={handleChange} value={form.name} label="Name" placeholder="Input name" required={true} />
                                <Input style={{ width: "100%", marginBottom: "20px" }} id="category" onChange={handleChange} value={form.category} label="Category Name" placeholder="Input category name" required={true} />
                                <Input style={{ width: "100%", marginBottom: "20px" }} id="description" onChange={handleChange} value={form.description} label="Description" placeholder="Type short description here" required={true} />
                                <InputImage style={{ width: "100%", marginBottom: "20px" }} id="thumbnail" label={"Upload Thumbnail"} value={form.thumbnail} onChange={(img) => handleImageChange(img, "thumbnail")} />
                                {/* Upload thumbnail image */}
                                <Input style={{ width: "100%", marginBottom: "20px" }} id="measuring_description" onChange={handleChange} value={form.measuring_description} label="Measuring Description" placeholder="Type measuring description here" />
                                {/* Attachment video */}
                                <InputImage style={{ width: "100%", marginBottom: "20px" }} id="attachments" label={"Attachments"} onChange={(img) => handleImageChange(img, "attachments")} />
                                <InputSwitch id="status" label={"Status"} isOn={isOn} onClick={() => handleSwitch("")} />
                            </div>
                            <hr style={{ width: "100%" }} />
                            <div className="footer-forms" style={{ marginTop: "20px" }}>
                                <Button type="button" className="btn-outline-primary" style={{ marginRight: "8px" }} title="Cancel" onClick={() => window.history.back()} />
                                <Button type="submit" className="btn-primary" title="Save" />
                            </div>
                        </div>
                    </form>
                )}
            />
            <LoadingModal isLoading={isLoading} />
        </>
    )
}
export default EditProductCategoryPage